<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Trámites Procesados</h4>
    <hr />
    <div class="mb-3 d-flex gap-2 flex-wrap">
      <button class="btn btn-outline-primary" @click="setToday">Hoy</button>
      <button class="btn btn-outline-danger" @click="setThisWeek">
        Semana Actual
      </button>
      <button class="btn btn-outline-secondary" @click="setThisMonth">
        Mes Actual
      </button>
      <button class="btn btn-outline-success" @click="setThisQuarter">
        Trimestre Actual
      </button>
      <button class="btn btn-outline-info" @click="setThisSemester">
        Semestre Actual
      </button>
      <button class="btn btn-outline-warning" @click="setThisYear">
        Año Actual
      </button>
    </div>

    <div class="input-group mb-4">
      <span class="input-group-text">Desde:</span>
      <input type="date" class="form-control" v-model="fechaDesde" />
      <span class="input-group-text">Hasta:</span>
      <input type="date" class="form-control" v-model="fechaHasta" />
      <button class="btn btn-dark" @click="filtrarTramites">Consultar</button>
    </div>
    <table id="sampleTable" class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Id.</th>
          <th scope="col">Mes</th>
          <th scope="col">Servicio</th>
          <th scope="col">Fecha desde</th>
          <th scope="col">Fecha hasta</th>
          <th scope="col">Estado AM</th>
          <th scope="col">Estado GD</th>
          <th scope="col" class="text-end">Atenciones</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="tramite in datosPaginados"
          :key="tramite.idTramite"
          @dblclick="handleRowClick($event, tramite.idTramite)"
        >
          <td>{{ tramite.idTramite }}</td>
          <td>{{ getFormattedMonthYear(tramite.fechaDesde) }}</td>
          <td>{{ tramite.servicioNombre }}</td>
          <td>{{ getFormattedDate(tramite.cargaFechaDesde) }}</td>
          <td>{{ getFormattedDate(tramite.cargaFechaHasta) }}</td>
          <td :class="tramite.cargaFechaFinAud ? 'procesado' : 'en-proceso'">
            {{ tramite.cargaFechaFinAud ? "PROCESADO" : "EN PROCESO" }}
          </td>
          <td :class="tramite.cargaFechaFinDoc ? 'procesado' : 'en-proceso'">
            {{ tramite.cargaFechaFinDoc ? "PROCESADO" : "EN PROCESO" }}
          </td>
          <td class="text-end">{{ tramite.numeroRegistros }}</td>
          <td>
            <select
              class="form-select form-select-sm"
              @change="handleAction($event, tramite.idTramite)"
            >
              <option disabled selected>Seleccione...</option>
              <option value="resumen">Resumen</option>
              <option value="detalles">Detalles</option>
              <option
                value="recibir"
                v-if="tramite.estadoTramite === 'ENVIADO'"
              >
                Recibir
              </option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>

    <!-- Botón para actualizar todos los trámites -->
    <div class="d-flex justify-content-center">
      <button
        @click="actualizarTodos"
        v-if="estadoBusqueda === 'ENVIADO'"
        class="btn btn-success"
      >
        Recibir Todos los Trámites
      </button>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">IdTramite</label>
                  </div>
                  <div class="col-10">
                    <span>{{ datoTramite.idTramite }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha de registro</label>
                  </div>
                  <div class="col-10">
                    <span>{{ getFormattedDate(datoTramite.fechaReg) }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Prestador</label>
                  </div>
                  <div class="col-10">
                    <span>{{ datoTramite.nombreComercial }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Servicio</label>
                  </div>
                  <div class="col-10">
                    <span>{{ datoTramite.servicioNombre }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">FechaDesde</label>
                  </div>
                  <div class="col-10">
                    <span>{{ getFormattedDate(datoTramite.fechaDesde) }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">FechaHasta</label>
                  </div>
                  <div class="col-10">
                    <span>{{ getFormattedDate(datoTramite.fechaHasta) }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Descripción</label>
                  </div>
                  <div class="col-10">
                    <span>{{ datoTramite.descripcion }}</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import {
  getToday,
  getThisWeek,
  getThisMonth,
  getThisQuarter,
  getThisSemester,
  getThisYear,
} from "@/modules/queryDateUtils.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      tramites: [],
      datoTramite: {},
      nombreBusqueda: "",
      estadoBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      //      prestadors: [],
      servicios: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
      prestadores: [],
      prestadorBusqueda: null,
      mensaje: "",
      idUsuario: 0,
      idPerfil: 0,
      tipo: "",
      fechaDesde: "",
      fechaHasta: "",
    };
  },

  mounted() {
    this.idUsuario = window.sessionStorage.getItem("idUsuario");
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    if (this.idPerfil == 17 || this.idPerfil == 18 || this.idPerfil == 22) {
      this.tipo = "aud";
    }
    if (this.idPerfil == 19 || this.idPerfil == 20) {
      this.tipo = "doc";
    }
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    handleRowClick(event, idTramite) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirEditar(idTramite);
    },
    handleAction(event, idTramite) {
      const action = event.target.value;
      if (action === "resumen") {
        this.abrirModalEditar(idTramite);
      } else if (action === "detalles") {
        this.abrirEditar(idTramite);
      }

      event.target.value = "Seleccione...";
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getFormattedMonthYear(date) {
      return dateFormat.getFormattedMonthYear(date);
    },
    totalPaginas() {
      return Math.ceil(this.tramites.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get(`/vwtramitecargas/procesados?idUsuario=${this.idUsuario}&tipo=${this.tipo}&fechaDesde=${this.fechaDesde}&fechaHasta=${this.fechaHasta}`
        )
        .then((response) => {
          this.tramites = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.tramites.slice(ini, fin);
        });
    },
    filtrarTramites() {
      this.getDataPaginaTodos(1); // reinicia en la primera página al filtrar
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      const requiredFieldsText = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    abrirModalEditar(idTramite) {
      this.modalWindow = true;
      if (idTramite != null) {
        api.get("/vwtramites/" + idTramite)
          .then((resp) => {
            this.datoTramite = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Resumen trámite " + idTramite;
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idTramite) {
      if (idTramite != null) {
        this.$router.push("/tramiteform/" + idTramite);
      }
    },
    setDateRange(getRangeFunction) {
      const dates = getRangeFunction();
      this.fechaDesde = dates.fechaDesde;
      this.fechaHasta = dates.fechaHasta;
      this.filtrarTramites();
    },
    setToday() {
      this.setDateRange(getToday);
    },
    setThisWeek() {
      this.setDateRange(getThisWeek);
    },
    setThisMonth() {
      this.setDateRange(getThisMonth);
    },
    setThisQuarter() {
      this.setDateRange(getThisQuarter);
    },
    setThisSemester() {
      this.setDateRange(getThisSemester);
    },
    setThisYear() {
      this.setDateRange(getThisYear);
    },
  },
};
</script>
<style scoped>
.procesado {
  background-color: #d4edda; /* verde claro */
  color: #155724; /* texto verde oscuro */
  font-weight: bold;
}

.en-proceso {
  background-color: #fff3cd; /* amarillo claro */
  color: #856404; /* texto amarillo oscuro */
  font-weight: bold;
}
</style>
